<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates27">
<p class="centerImage"><img alt="images" id="plate27" src="images/plate27.jpg"/></p>
<p class="caption">Me standing by John Lenagen’s Spitfire BS181 in which I shot down a Dinah recce. aircraft on 6 February 1943, the first Spitfire victory in Australia. John had his girlfriend’s name painted on the cowling.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates27.vue?703990d8